import React, { useEffect } from 'react';
function getScrollLeft(contentNode, scrollToIndex = 0) {
    // if scrollToIndex value is not valid - get the first item index
    const actualScrollToIndex = Math.max(0, Math.min(scrollToIndex, contentNode.children.length - 1));
    const scrollToChild = contentNode.children[actualScrollToIndex];
    if (!scrollToChild) {
        return null;
    }
    return Math.max(0, scrollToChild.offsetLeft - (contentNode.offsetWidth - scrollToChild.offsetWidth) / 2);
}
/** Handle scrolling to a particular item */ export function useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll) {
    useEffect(()=>{
        requestAnimationFrame(()=>{
            const contentNode = contentRef.current;
            const rootNode = rootRef.current;
            if (!contentNode || !rootNode) {
                return;
            }
            const currentScrollLeft = contentNode.scrollLeft;
            const scrollLeft = getScrollLeft(contentNode, scrollToIndex);
            if (scrollLeft !== currentScrollLeft && scrollLeft !== null) {
                if (smoothInitialScroll) {
                    contentNode.scrollLeft = scrollLeft;
                } else {
                    // scrollTo with a behavior parameter doesn't
                    // behave if the behavior is set in CSS...
                    contentNode.style.scrollBehavior = 'auto';
                    contentNode.scrollLeft = scrollLeft;
                    contentNode.style.scrollBehavior = 'smooth';
                }
            }
        });
    }, [
        contentRef,
        rootRef,
        scrollToIndex,
        smoothInitialScroll
    ]);
}

//# sourceMappingURL=useSliderScrollToIndex.js.map